<template>
    <div class="exp_it">
        <div id="panel-4" class="panel">
            <div class="panel-hdr ">
                <h2>
                    {{__t('LIST')}} <span class="fw-300"><i>{{__t('ORDERS')}}</i></span>
                </h2>

                <div class="panel-toolbar">
                    <button class="btn btn-panel waves-effect waves-themed"
                            data-action="panel-fullscreen"
                            data-toggle="tooltip" data-offset="0,10" data-original-title="Fullscreen">
                    </button>
                </div>
            </div>

            <div class="panel-container show">
                <div class="panel-content">
                    <date-picker
                        value-type="format"
                        v-model="time_range"
                        :lang="d_lang"
                        range
                        :first-day-of-week="1"
                        :shortcuts="shortcuts" confirm>

                    </date-picker>
                </div>
            </div>
            <b-overlay :show="loading">
            <div class="modal-footer">
                <button type="button" v-on:click="export_it" class="btn btn-secondary waves-effect waves-themed">
                    {{__t('EXPORT')}}
                </button>

            </div>
            </b-overlay>
        </div>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
export default {
    name: "export_customers",
    components: {DatePicker},
    data() {
        return {
            loading : false,
            time_range : "",
            time_range_start: [
                new Date(), new Date()
            ],
            shortcuts: [
                {
                    onClick: () => {
                        this.time_range_start
                    }
                }
            ],
        }
    },
    methods : {
        async export_it() {
            this.loading = true;
           /* axios({
                method: 'post',
                url: '/internal/prep_data/glovo/customers/',
                data: {'period' :this.time_range},
                responseType: 'blob'
            }).then(res => {
                const link = document.createElement('a')
                const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
                link.style.display = 'none'
                link.href = URL.createObjectURL(blob)
                link.setAttribute('download', `${name}.xlsx`)
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)

            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });*/

            await api.post('/internal/prep_data/glovo/customers/',{'period' :this.time_range},)
                .then(({data}) => {
                    this.loading = false;
                    console.log(data);
                    if(data.data != null ) {
                        window.open('https://api.getorder.biz/' + data.data, '_blank');
                    }


            }).catch(({response}) => {
                this.loading = false;
                    EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        }
    },

    computed : {
        d_lang() {
            return this.get_datepickLang();
        },

    }
}
</script>

<style scoped>

</style>
